import React, { memo, useMemo } from "react";
import { useAgentsStore } from "../../../../../../store/agents.store";
import { selectAgentDetail, selectAllStates } from "../../../../../../store/agentDetail/agentDetailSelectors";
import { IState } from "../../../../../../agentDetail.model";
import { StatusBadge } from "./components/statusBadge/statusBadge.index";
import { renderIcon, renderValue } from "./leftSection.utils";
import { LeftSectionItemId, NEVER_LOGGED_IN } from "./leftSection.constants";
import styles from "./leftSection.module.css";

export const LeftSection = memo(() => {
    const allStates = useAgentsStore(selectAllStates);
    const agentDetails = useAgentsStore(selectAgentDetail)?.personalInformation;
    const displayName = `${agentDetails?.firstName ?? ""} ${agentDetails?.lastName ?? ""}`.trim();
    const userDisplayImage = agentDetails?.userDisplayImage ?? "";
    const isActive = agentDetails?.isActive ?? false;

    const userInfo = useMemo(
        () =>
            [
                { id: LeftSectionItemId.EMAIL, value: agentDetails?.email },
                { id: LeftSectionItemId.PHONE_NUMBER, value: agentDetails?.primaryPhoneNumber },
                {
                    id: LeftSectionItemId.STATE,
                    value:
                        allStates?.find((state: IState) => state.stateCode === agentDetails?.state)?.stateTitle ??
                        agentDetails?.state,
                },
                { id: LeftSectionItemId.CREATED_ON, value: agentDetails?.createdOn },
                { id: LeftSectionItemId.LAST_LOGIN_ON, value: agentDetails?.lastLoginOn ?? NEVER_LOGGED_IN },
            ].filter((item) => item.value),
        [agentDetails, allStates]
    );

    return (
        <div className={styles.container}>
            <div className={styles.profileCardHeader}>
                {userDisplayImage && (
                    <div className={styles.profileCardAvatar}>
                        <img src={userDisplayImage} alt={displayName} loading="lazy" />
                    </div>
                )}
                <div className={styles.profileCardNameContainer}>
                    <h2 className={styles.profileCardName}>{displayName}</h2>
                    <div className={styles.profileCardStatusBadge}>
                        <StatusBadge isActive={isActive} />
                    </div>
                </div>
            </div>
            <div className={styles.profileCardDetails}>
                {userInfo.map((item) => (
                    <div key={item.id} className={styles.profileCardDetailsItem}>
                        <div className={styles.profileCardDetailsItemIcon}>{renderIcon(item.id)}</div>
                        <span className={styles.profileCardDetailsItemValue}>
                            {renderValue(String(item.value), item.id)}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
});
